import React from 'react';
import { useParams } from 'react-router-dom';

import { useExhibitions } from '~/hooks/exhibitions';
import CompanyForm from '~/components/form/CompanyForm/index';
import styles from '../create/create.module.scss';

const EditFournisseur = () => {
  const { id } = useParams();
  const { isLoading: isExhibitionsLoading } = useExhibitions();

  if (isExhibitionsLoading) {
    return <p>Loading</p>;
  }

  return (
    <div className={styles.create}>
      <CompanyForm companyType="fournisseur" companyId={id} />
    </div>
  );
};

export default EditFournisseur;
